import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { createJob, updateJob, getLead, linkLeadJob } from '../utils/api';
import JobForm from '../components/JobForm';
import toast from 'react-hot-toast';

export default function AddRecord() {
  const [loading, setLoading] = useState(false);
  const [savedJobId, setSavedJobId] = useState(null);
  const navigate = useNavigate();
  // Opened from a Sold appointment on the Dispatch Board: fill the form in from the appointment
  const leadId = useSearchParams()[0].get('lead');
  const [initial, setInitial] = useState(leadId ? null : undefined);
  useEffect(() => {
    if (!leadId) return;
    getLead(leadId).then(l => {
      const svc = {}; (l.products || []).slice(0, 4).forEach((p, i) => { svc['svc' + (i + 1)] = p; });
      const [r1, r2] = l.reps || [];
      setInitial({ customer_name: l.customer || '', customer_name_2: l.customer_2 || '', phone: l.phone || '', phone_2: l.phone_2 || '', email: l.email || '',
        address: l.address || '', city: [l.city, l.zip].filter(Boolean).join(' '), contract_date: l.appt_date || '', contract_amt: l.amount ? String(l.amount) : '',
        sales_rep: r1 || '', ...(r2 ? { sales_rep_2: r2, sales_rep_split: '50', sales_rep_2_split: '50' } : {}),
        ...(l.source === 'Telemarketing' ? { telemarketer: l.set_by || '' } : { canvasser: l.set_by || '' }), confirmer: l.confirmer || '', ...svc });
    }).catch(() => { toast.error('Could not load that appointment'); setInitial(undefined); });
  }, [leadId]);
  const linkLead = job => { if (leadId && job?.id) linkLeadJob(leadId, job.id).catch(() => {}); };

  // Final "Save" click.
  // If the form already auto-saved this record (because the user opened the
  // Attachments/Contracts tab), UPDATE that same record instead of creating a
  // second one. Creating again is what produced duplicate/"ghost" records.
  async function handleSubmit(data) {
    setLoading(true);
    try {
      const job = savedJobId
        ? await updateJob(savedJobId, data)
        : await createJob(data);
      setSavedJobId(job.id);
      if (!savedJobId) linkLead(job);
      toast.success(`Record ${savedJobId ? 'updated' : 'added'}: ${job.po_number}`);
      navigate('/tracker');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to save record');
    } finally {
      setLoading(false);
    }
  }

  // Auto-save silently when user clicks the Attachments / Contracts tab.
  // Only ever creates once; afterwards the id is reused by handleSubmit.
  async function handleAutoSave(data) {
    if (savedJobId) {
      const job = await updateJob(savedJobId, data);
      return job;
    }
    const job = await createJob(data);
    setSavedJobId(job.id);
    linkLead(job);
    return job;
  }

  return (
    <>
      <div className="page-header">
        <h2>Add Record</h2>
        {savedJobId && (
          <button className="btn btn-outline btn-sm" onClick={() => navigate('/tracker')}>
            Go to Job Tracker
          </button>
        )}
      </div>
      <div className="page-body">
        <div className="card">
          <div className="card-body">
            {leadId && initial && <div style={{ background: '#E3F3EA', border: '1px solid #9CD3B2', borderRadius: 10, padding: '10px 14px', marginBottom: 14, fontSize: 14 }}>Filled in from the Sold appointment. Add the PO number and check the details before saving.</div>}
            {initial === null ? <div className="loader"><div className="spinner" /></div> : <JobForm
              initial={initial}
              onSubmit={handleSubmit}
              submitLabel="Add to Tracker"
              loading={loading}
              jobId={savedJobId}
              onAutoSave={handleAutoSave}
            />}
          </div>
        </div>
      </div>
    </>
  );
}
